import React, { useState, useEffect } from 'react';
import { Row, Col, Collapse } from 'antd';
import { Link, useLocation,useNavigate } from 'react-router-dom';
import '../../../assets/css/patrocinadores.css';
import { CaretRightOutlined, LeftOutlined } from '@ant-design/icons';
import { Element } from 'react-scroll/modules';

import log_blanco from '../../../assets/images/sitio/03_Patrocinadores_sitio_IES/Ies_Signify.png';

import banner from '../../../assets/images/2022/stands/interiores/completos/stands_ind_-signify.jpg';

import img_wsp_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_az.png';
import img_wsp from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_az.png';
import img_email_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_az.png';
import img_email from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_az.png';
import img_wsp_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_az.png';
import img_wsp_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_az.png';
import img_email_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_az.png';
import img_email_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_az.png';

import btn_fb_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_Az.png';
import btn_fb from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_Az.png';
import btn_tw from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_Az.png';
import btn_tw_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_Az.png';
import btn_yt from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_youtube_az.png';
import btn_yt_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_youtube_az.png';
import btn_in from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_az.png';
import btn_in_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_az.png';
import btn_lk from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_linkedin_az.png';
import btn_lk_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_linkedin_az.png';


const Signify = (props) => {
  const { Panel } = Collapse;
  const { idioma, onMetrica, nombre } = props;
  const [hover_imagen, setHoverImagen] = useState(0);
  const [hover_redes, setHoverRedes] = useState(0);

  return (
    <>
      <Row align='middle'>
        <Col span={24}>
          <br /><br /><br /><br />
        </Col>
        <Col xs={{ span: 4, offset: 1 }} md={{ span: 2, offset: 2 }}>
                  <p className="salir_patrocinador">
          <Link to="/#patrocinadores" className="salir_patrocinador"><LeftOutlined /> {idioma === 'es' ? 'Salir' : 'Get out'}</Link>
          </p>
        </Col>
        <Col xs={{ span: 8, offset: 1 }} md={{ span: 4, offset: 5 }}>
          {idioma==='es' ?
            <img src={log_blanco} style={{width:'100%'}} />
          :
          <img src={log_blanco} style={{width:'100%'}} />}
        </Col>
      </Row>
      <Row>
      <Col span={24} offset={0}>
        <a href="#" onClick={()=>{onMetrica('video',nombre)}}>
          <img src={banner} style={{width:'100%'}} onClick={()=>onMetrica('video',nombre)} />
        </a>
        <br /><br />
        </Col>
        <Col span={20} offset={2}>
         {idioma === 'es' ?
         <p className="texto_patrocinadores">
           <span className='color_verde'><strong>SOBRE NOSOTROS</strong></span>
            <br />
          Signify es el líder mundial en iluminación para profesionales y consumidores en alumbrado para el Internet de las cosas. 
          <br /><br />
          Desde mayo de 2018, Signify es el nuevo nombre de empresa de Philips Lighting. Fundada como Philips en Eindhoven, Países Bajos, la compañía ha conducido la industria de la iluminación a través de innovaciones tecnológicas, durante más de 128 años. En 2016, se separó de Philips, convirtiéndose en una compañía independiente, cotizando en la bolsa de Ámsterdam. Fue incluida en el índice de referencia AEX en marzo de 2018.
        </p>
        :
        <p className="texto_patrocinadores">
          <span className='color_verde'><strong>ABOUT OUS</strong></span><br />
        Signify is the global leader in lighting for professionals and consumers in lighting for the Internet of Things.
        <br /><br />
        Since May 2018, Signify is the new company name for Philips Lighting. Founded as Philips in Eindhoven, the Netherlands, the company has led the lighting industry through technological innovations for more than 128 years. In 2016, it parted ways with Philips, becoming an independent company, listed on the Amsterdam Stock Exchange. It was included in the AEX benchmark index in March 2018.
      </p>}
        </Col>
        <Col span={16} offset={4} onClick={()=>onMetrica('video',nombre)}>
        <br />
        <div className="contenedor_video_patrocinador">
        <iframe className="video" src="https://www.youtube.com/embed/WUWBx9unhLc?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          
          <br /><br />
        </Col>
        <Element name="#video"/>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:4}} className="paddin_20">
          {idioma === 'es' ?
          <a onClick={()=>onMetrica('whatsapp',nombre)} target="_blank" href="https://api.whatsapp.com/send?phone=525545669609&text=Hola,%20me%20contacto%20desde%20el%20stand%20de%20Signify%20de%20la%20IES." onMouseEnter={()=>setHoverImagen(1)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 1 ? img_wsp_hover : img_wsp} style={{width:'100%'}} alt="whatsapp" /></a>
        :
        <a onClick={()=>onMetrica('whatsapp',nombre)} target="_blank" href="https://api.whatsapp.com/send?phone=525545669609&text=Hello,%20contact%20me%20from%20the%20Signify%20booth%20at%20IES." onMouseEnter={()=>setHoverImagen(1)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 1 ? img_wsp_en_hover : img_wsp_en} style={{width:'100%'}} alt="whatsapp" /></a>}
        </Col>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:0}} className="paddin_20" style={{display:'non'}}>
        {idioma === 'es' ?
        <a onClick={()=>onMetrica('mail',nombre)} target="_blank" href="mailto:aida.sordo@signify.com"><img src={img_email} style={{width:'100%'}} alt="email" /></a>
      :
      <a onClick={()=>onMetrica('mail',nombre)} target="_blank" href="mailto:aida.sordo@signify.com"><img src={img_email} style={{width:'100%'}} alt="email" /></a>}
        </Col>
       </Row>
      <Row>
        <Col span={16} offset={4}>
          <br /><br />
        </Col>
        <Col span={20} offset={2}>
        {idioma === 'es' ?
          <p className="titulo_patrocinador_texto">PREGUNTAS FRECUENTES</p>
        :
        <p className="titulo_patrocinador_texto">FREQUENT QUESTIONS</p>
        }
        </Col>
        <Col span={20} offset={2}>
          <Collapse
            bordered={false}
            defaultActiveKey={['1']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            className="site-collapse-custom-collapse"
          >
            {idioma === 'es' ?
            <Panel header="¿Por qué se cambió el nombre de Philips a Signify?" key="1" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  El cambio de nombre es parte de la evolución en la industria en la era de LED y el Internet de las cosas (IoT), en la que los proveedores de iluminación están tratando de conectar las luces a Internet a través de esquemas cableados e inalámbricos. La idea es otorgar a los usuarios un mayor control de la luz a través de la conectividad para convertir la infraestructura de iluminación en una red de recopilación y análisis de datos que permita generar acciones para atraer a los compradores a las tiendas, mejorar la calidad del aire y el flujo de tráfico en las autopistas, entre muchas más posibilidades.
                  </p>
            </Panel>
            :
            <Panel header="Why was the Philips name changed to Signify?" key="1" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  The name change is part of the evolution in the industry in the era of LEDs and the Internet of Things (IoT), in which lighting providers are trying to connect lights to the Internet via wired and wireless schemes. The idea is to give users greater control of light through connectivity to turn the lighting infrastructure into a data collection and analysis network that allows generating actions to attract buyers to stores, improve the quality of the lighting. air and traffic flow on highways, among many more possibilities.
                  </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Cómo se ve Signify en números?" key="2" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Sus operaciones están presentes en más de 70 países, cuenta con aproximadamente 36,000 empleados alrededor del mundo. En 2019 generó ventas aproximadamente de 6,200 miles de millones de euros, y una inversión de 4,5% en investigación y desarrollo.
                  </p>
            </Panel>
            :
            <Panel header="What does Signify look like in numbers?" key="2" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Its operations are present in more than 70 countries, it has approximately 36,000 employees around the world. In 2019, it generated sales of approximately 6.2 billion euros, and an investment of 4.5% in research and development.
                  </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Cuál es el principal objetivo de Signify?" key="3" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  El principal objetivo de Signify es desbloquear el extraordinario potencial de la luz para ofrecer vidas más brillantes y un mundo mejor. Han sido nombrados Líderes de Industria en el índice de sostenibilidad de Dow Jones durante dos años consecutivos.
                  </p>
            </Panel>
            :
            <Panel header="What is the main objective of Signify?" key="3" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Signify's main goal is to unlock the extraordinary potential of light to deliver brighter lives and a better world. They have been named an Industry Leader in the Dow Jones Sustainability Index for two consecutive years.
                  </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Cuáles son sus marcas?" key="4" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Signify se enorgullece de comercializar grandes marcas de iluminación a nivel mundial.
                  </p>
                  <ul className="texto_patrocinadores">
                  <li>Philips: marca mundial de iluminación profesional y para consumidores</li>
                  <li>Interact: plataforma de Internet de las cosas y sistemas de iluminación conectados a través de los servicios habilitados para datos que entregan valor comercial y transforman la vida en hogares, edificios y espacios públicos</li>
                  <li>Color Kinetics: marca mundial de sistemas de iluminación arquitectónica dinámica</li>
                  <li>Hue: Sistema de iluminación inalámbrica inteligente</li>
                  <li>WiZ: Iluminación inteligente para tu vida diaria</li>
                  </ul>
            </Panel>
            :
            <Panel header="What are your brands?" key="4" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Signify is proud to market great lighting brands globally.
                  </p>
                  <ul className="texto_patrocinadores">
                    <li>Philips: global consumer and professional lighting brand</li>
                    <li>Interact: Internet of Things platform and lighting systems connected through data-enabled services that deliver business value and transform life in homes, buildings and public spaces</li>
                    <li>Color Kinetics: a global brand for dynamic architectural lighting systems</li>
                    <li>Hue: Smart Wireless Lighting System</li>
                    <li>WiZ: Smart lighting for your daily life</li>
                  </ul>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Como contribuye Signify con la Agenda 2030?" key="5" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  A principio de septiembre Signify anunció que logro la neutralidad de carbono para todas sus operaciones en todo el mundo. Signify ha reducido sus emisiones operativas en más de un 70% desde 2010, tras haber cambiado a tecnologías más eficientes desde el punto de vista energético en sus sitios, a modos de transporte más sostenibles y planificación logística optimizada, y a menos viajes de una manera más sostenible. 
                  <br />
                  También utiliza electricidad 100% renovable, respaldada a través de dos acuerdos de compra de energía, uno en Texas y otro en Polonia. El equilibrio de la reducción de emisiones se logra a través de un programa de compensación de carbono con proyectos destinados a beneficiar el bienestar de las comunidades locales.
                  </p>
            </Panel>
            :
            <Panel header="How does Signify contribute to the 2030 Agenda?" key="5" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  In early September Signify announced that it has achieved carbon neutrality for all of its operations around the world. Signify has reduced its operational emissions by more than 70% since 2010, having switched to more energy efficient technologies at its sites, more sustainable modes of transport and optimized logistics planning, and fewer trips in a more efficient way. sustainable.
                  <br />
                  It also uses 100% renewable electricity, backed by two power purchase agreements, one in Texas and one in Poland. Balancing emissions reduction is achieved through a carbon offset program with projects aimed at benefiting the well-being of local communities.
                  </p>
            </Panel>}
            {idioma === 'es'?
            <Panel header="¿Tiene plantas en América Latina?" key="6" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Sí, Signify actualmente cuenta con 5 plantas de producción en América Latina; 4 en México, y 1 en Brasil, además de contar oficinas corporativas en Ciudad de México.
                  </p>
            </Panel>
            :
            <Panel header="Do you have plants in Latin America?" key="6" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Yes, Signify currently has 5 production plants in Latin America; 4 in Mexico, and 1 in Brazil, in addition to having corporate offices in Mexico City.
                  </p>
            </Panel>}
          </Collapse>
        </Col>
        <Col span={20} offset={2}>
        <br /><br />
        {idioma === 'es' ?
        <p className="tituLogos">Obtener más información</p>
        :
        <p className="tituLogos">Get more information</p>}
        </Col>
        <Col xs={{span:10,offset:7}} md={{span:6,offset:9}}>
        
        <Row justify='center'>
          <Col span={0} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('facebook',nombre)} href="" target="_blank"><img src={btn_fb} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('twitter',nombre)} href="https://twitter.com/SignifyMexico" target="_blank"  onMouseEnter={()=>setHoverRedes(1)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 1 ? btn_tw_hover : btn_tw} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={0} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('youtube',nombre)} href="" target="_blank"><img src={btn_yt} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={0} className="contenedor_redes_patrocinadores contenedor_redes_patrocinadores_rigth">
            <a onClick={()=>onMetrica('instagram',nombre)} href="" target="_blank"><img src={btn_in} className="patrocinadores_redes_img" /></a>
          </Col>
        </Row>
        <br />
        </Col>
      </Row>
    </>
  )
}
export default Signify;